// extracted by mini-css-extract-plugin
export var dropdownToggle = "DropdownToggle_dropdownToggle__LVfcx";
export var active = "DropdownToggle_active__0ez36";
export var icon = "DropdownToggle_icon__8AmUk";
export var text = "DropdownToggle_text__DlwO3";
export var rotate = "DropdownToggle_rotate__KSXgw";
export var dotty = "DropdownToggle_dotty__DEKUP";